import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { ListItem, TextField, IconButton } from 'material-ui';
import R from 'ramda';

import { updateProps as updatePropsAction } from '../../../stores/profile/memberships/actions';
import AddOrgLink from './addOrgLink';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class AddOrg extends Component {
  constructor() {
    super();
    this.state = {
      searchingForOrg: '',
      filteredOrgList: null,
      showListOfOrganizationsDropdown: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (R.isEmpty(nextProps.membership) && R.isEmpty(nextProps.otherMembership)) {
      this.state = {
        searchingForOrg: '',
        filteredOrgList: null,
        showListOfOrganizationsDropdown: false,
      };
    }
  }

  render() {
    const {
      updateProps,
      listOfAvailableOrganizations,
      membership,
      otherMembership,
      userMemberships,
    } = this.props;
    const { searchingForOrg, filteredOrgList, showListOfOrganizationsDropdown } = this.state;

    const selectFieldOptions = () => {
      const membershipList = [];
      (showListOfOrganizationsDropdown ? listOfAvailableOrganizations : filteredOrgList).map(org => membershipList.push(
        { value: org.name, label: org.name }
      ));
      const uniqueOrganizations = [];
      const existingOrganizations = userMemberships.map(org => {
        if (!org.delete) return org.name;
      });
      const organizationsFromDropdown = membershipList.map(org => org.value);
      const duplicatedOrganizations = R.intersection(existingOrganizations, organizationsFromDropdown);
      membershipList.map(org => {
        if (!R.contains(org.value, duplicatedOrganizations)) uniqueOrganizations.push(org);
      });
      return uniqueOrganizations;
    };

    const findSelectedOrganizationInfo = organizationName => listOfAvailableOrganizations.filter(org => org.name === organizationName);
    return (
      <div>
        <div style={{ float: 'left', color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', width: '45%' }}>
          <span>Organization Name</span>
        </div>
        <div style={{ float: 'right', width: '50%', marginRight: '10px', zIndex: '1' }}>
          <TextField
            name="organizationDropdown"
            key="organizationDropdown"
            id="organizationDropdown"
            value={searchingForOrg}
            onChange={({ target: { value } }) => {
              this.setState({ searchingForOrg: value });
              if (isNilOrEmpty(value)) {
                this.setState({ filteredOrgList: null });
                updateProps({ membership: {}, otherMembership: {}, showAddAnotherOrganizationButton: false });
              } else {
                this.setState({ showListOfOrganizationsDropdown: false, filteredOrgList: listOfAvailableOrganizations.filter(org =>
                  org.name.toLowerCase().includes(searchingForOrg.toLowerCase())) });
              }
            }}
            style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', marginBottom: '15px' }}
            inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' }}
            underlineShow={false}
            hintText={
              <div style={{ width: '100%', height: '25px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', marginLeft: '5px' }}>Search For Organization...</div>
                <div style={{ display: 'flex' }}>
                  <IconButton iconClassName="tc-icon-arrow-drop-down" onTouchTap={() => this.setState({ showListOfOrganizationsDropdown: !showListOfOrganizationsDropdown })} />
                </div>
              </div>
            }
            hintStyle={{ fontSize: '12px', width: '100%', height: '34px', top: '5px' }}
          />
          <div style={{ margin: '-15px 0 10px 0', maxHeight: '300px', overflowY: 'scroll' }}>
            {
              ((!isNilOrEmpty(filteredOrgList) && isNilOrEmpty(membership)) || showListOfOrganizationsDropdown) &&
                selectFieldOptions().map((org, i) => {
                  return (
                    <ListItem
                      key={i}
                      style={{ border: '1px solid #eeeeee', minHeight: '34px', overflow: 'hidden' }}
                      primaryText={
                        <div style={{ color: 'rgba(0, 0, 0, 0.54)', marginTop: '-7px', fontSize: 'calc(8px + 0.4vw)' }}>
                          <div style={{ float: 'left', width: '70%', marginBottom: '5px' }}>
                            {org.label}
                          </div>
                        </div>
                      }
                      rightIconButton={<AddOrgLink orgInfo={findSelectedOrganizationInfo(org.label)} />}
                      onTouchTap={() => {
                        this.setState({ searchingForOrg: org.value, showListOfOrganizationsDropdown: false });
                        updateProps({
                          membership: R.merge(membership, {
                            name: org.value,
                            type: 'organization',
                            badgeId: R.path([0, 'badgeId'], listOfAvailableOrganizations.filter(organ => R.equals(organ.name, org.value))),
                          }),
                        });
                      }}
                    />
                  );
                })
            }
          </div>
          {
            !isNilOrEmpty(searchingForOrg) && isNilOrEmpty(filteredOrgList) && isNilOrEmpty(membership) &&
              <TextField
                name="otherMembershipId"
                id="otherMembershipId"
                value={R.propOr('', 'membershipId', otherMembership)}
                onChange={({ target: { value } }) => updateProps({
                  otherMembership: {
                    membershipId: value,
                    name: searchingForOrg,
                  },
                })}
                style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', margin: '5px 0 15px 0' }}
                inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' }}
                underlineShow={false}
                hintText="Membership ID"
                hintStyle={{ marginLeft: '5px', fontSize: '12px', marginBottom: '-5px', maxHeight: '20px' }}
              />
          }
          {
            !isNilOrEmpty(membership) && !isNilOrEmpty(searchingForOrg) &&
              <TextField
                name="membershipId"
                id="membershipId"
                value={R.propOr('', 'membershipId', membership)}
                onChange={({ target: { value } }) => updateProps({
                  membership: R.merge(membership, {
                    membershipId: value,
                    badgeId: R.path([0, 'badgeId'], listOfAvailableOrganizations.filter(org => R.equals(org.name, membership.name))),
                  }),
                })}
                style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', height: '34px', margin: '5px 0 15px 0' }}
                inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', marginBottom: '-8px', paddingLeft: '5px' }}
                underlineShow={false}
                hintText="Membership ID"
                hintStyle={{ marginLeft: '5px', fontSize: '12px', marginBottom: '-5px', maxHeight: '20px' }}
              />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ membershipsReducer, user, companyProfile }) => ({
  listOfAvailableOrganizations: membershipsReducer.get('listOfAvailableOrganizations').toJS(),
  membership: membershipsReducer.get('membership').toJS(),
  user: user.toJS(),
  companyProfile: companyProfile.toJS(),
  userMemberships: membershipsReducer.get('memberships').toJS(),
  otherMembership: membershipsReducer.get('otherMembership').toJS(),
});

const mapDispatchToProps = ({
  updateProps: updatePropsAction,
});

AddOrg.propTypes = {
  updateProps: PropTypes.func,
  listOfAvailableOrganizations: PropTypes.array,
  userMemberships: PropTypes.array,
  membership: PropTypes.object,
  otherMembership: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddOrg);



// WEBPACK FOOTER //
// ./src/app/components/profile/memberships/addOrg.jsx